import { makeStyles } from '@material-ui/styles'

const stepCardStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  stepContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${theme.spacing(1.3)}px ${theme.spacing(2)}px`,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    borderRadius: theme.shape.borderRadius,
    border: `4px solid ${theme.palette.common.white}`,
    zIndex: 1,
    marginBottom: -theme.spacing(3.5),
  },
  childrenContainer: {
    width: '-webkit-fill-available',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: `${theme.spacing(4.8)}px ${theme.spacing(3.2)}px`,
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
  },
  childrenContainerNoSteps: {
    width: '-webkit-fill-available',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: `${theme.spacing(1.6)}px ${theme.spacing(3.2)}px`,
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
  },
  boldFont: {
    fontWeight: theme.typography.fontWeightBold,
  },
}))

export default stepCardStyles
